import { useLanguage } from '../context/LanguageContext';
import { X, Sparkles, Bookmark, RefreshCw, ArrowLeft } from 'lucide-react';
import { useState, useEffect, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CARDS_HE = [
  'רגוע/ה','נוכח/ת','אמיץ/ה','מקבל/ת','פתוח/ה','סקרן/ית','קשוב/ה','יציב/ה','גמיש/ה','סבלני/ת','אותנטי/ת','עדין/ה','ממוקד/ת','מחובר/ת','שלם/ה','בטוח/ה','חי/ה','ער/ה','משוחרר/ת','אוהב/ת',
  'אני נוכח/ת עם מה שיש בי עכשיו','אני מקבל/ת את עצמי כמו שאני','אני סומך/ת על הקצב שלי','אני מאפשר/ת למה שעולה להיות כאן','אני בוחר/ת להיות רגוע/ה מול מה שמגיע','אני קשוב/ה לגוף שלי','אני נותן/ת מקום לרגש בלי לברוח','אני פועל/ת גם כשיש פחד','אני נשאר/ת איתי גם כשקשה','אני מרשה לעצמי להרגיש','אני לא צריך/ה לתקן את עצמי עכשיו','אני מחובר/ת למה שחשוב לי','אני נותן/ת לעצמי זמן','אני בוחר/ת אמת גם כשזה לא נוח','אני רואה אותי בלי שיפוט','אני נושם/ת ונרגע/ת','אני נותן/ת לעצמי להיות אנושי/ת','אני משחרר/ת מאבק מיותר','אני נפתח/ת למה שיש','אני בטוח כאן','אני סומך/ת על עצמי',
  'עצור/י פעם אחת היום ושאל/י מה את/ה חש/ה','קח/י 3 נשימות לפני תגובה','שים/י לב לגוף שלך עכשיו','כתוב/י משפט אחד על מה שעובר עליך','דבר/י אמת אחת קטנה היום','שים/י לב מתי את/ה מתרחק/ת מעצמך','בחר/י תגובה אחת שונה מהרגיל','האט/י לרגע אחד במהלך היום','הקשב/י למישהו בלי לקטוע','שים/י לב לביקורת שעולה ותן/י לה מקום','בחר/י להיות כנה בשיחה אחת','בדוק/י מה את/ה צריך/ה עכשיו','תן/י שם לרגש שעולה בך','שב/י דקה אחת בלי מסך','הסכים/י להרגיש גם חוסר נוחות','בחר/י פעולה אחת שמקדמת אותך','שים/י לב לנשימה שלך כמה פעמים היום','תן/י לעצמך רגע של שקט','בדוק/י איפה את/ה מתאמץ/ת יותר מדי','בחר/י להיות איתך לפני הכל',
  'תגיד/י למישהו בחייך שאת/ה אוהב/ת אותו/ה','שלח/י הודעה למישהו שאת/ה מתגעגע/ת אליו/ה','תגיד/י בוקר טוב ל-3 אנשים בדרך שלך','חייך/י למישהו זר','שאל/י מישהו קרוב איך הוא באמת מרגיש','התקשר/י למישהו שלא דיברתם זמן','פרגן/י למישהו על משהו ספציפי','הצע/י עזרה קטנה למישהו היום','הקשב/י למישהו בלי לתת פתרון','שלח/י הודעת תודה למישהו שעזר לך',
];

const CARDS_EN = [
  'Calm','Present','Brave','Accepting','Open','Curious','Attentive','Stable','Flexible','Patient','Authentic','Gentle','Focused','Connected','Whole','Safe','Alive','Awake','Free','Loving',
  'I am present with what is in me right now','I accept myself as I am','I trust my own pace','I allow what arises to be here','I choose to be calm with what comes','I am attentive to my body','I give space to emotion without running','I act even when there is fear','I stay with myself even when it\'s hard','I allow myself to feel','I don\'t need to fix myself right now','I am connected to what matters to me','I give myself time','I choose truth even when it\'s uncomfortable','I see myself without judgment','I breathe and relax','I allow myself to be human','I release unnecessary struggle','I open up to what is','I am safe here','I trust myself',
  'Stop once today and ask what you feel','Take 3 breaths before reacting','Notice your body right now','Write one sentence about what you\'re going through','Speak one small truth today','Notice when you distance yourself from yourself','Choose one response different from usual','Slow down for one moment during the day','Listen to someone without interrupting','Notice the criticism that arises and give it space','Choose to be honest in one conversation','Check what you need right now','Name an emotion rising in you','Sit for one minute without a screen','Agree to feel discomfort too','Choose one action that moves you forward','Notice your breathing a few times today','Give yourself a moment of quiet','Check where you\'re trying too hard','Choose to be with yourself before everything',
  'Tell someone in your life that you love them','Send a message to someone you miss','Say good morning to 3 people on your way','Smile at a stranger','Ask someone close how they really feel','Call someone you haven\'t spoken to in a while','Compliment someone on something specific','Offer small help to someone today','Listen to someone without offering a solution','Send a thank you message to someone who helped you',
];

const CardGameModal = ({ isOpen, onClose, onBookCall }) => {
  const { language } = useLanguage();
  const cards = language === 'he' ? CARDS_HE : CARDS_EN;
  
  const [currentCard, setCurrentCard] = useState(null);
  const [isRevealing, setIsRevealing] = useState(false);
  const [savedCards, setSavedCards] = useState([]);
  const [remaining, setRemaining] = useState(3);
  const [limitReached, setLimitReached] = useState(false);
  const [lastPulledIndex, setLastPulledIndex] = useState(-1);
  const [showSaved, setShowSaved] = useState(false);

  // Load saved cards from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('savedCards');
    if (saved) setSavedCards(JSON.parse(saved));
  }, []);

  // Check remaining pulls on open
  useEffect(() => {
    if (isOpen) {
      fetch(`${API_URL}/api/card-pull/status`)
        .then(r => r.json())
        .then(data => {
          setRemaining(data.remaining);
          setLimitReached(data.remaining <= 0);
        })
        .catch(() => {});
    }
  }, [isOpen]);

  const pullCard = useCallback(async () => {
    if (isRevealing || limitReached) return;

    try {
      const res = await fetch(`${API_URL}/api/card-pull`, { method: 'POST' });
      if (res.status === 429) {
        setLimitReached(true);
        return;
      }
      const data = await res.json();
      setRemaining(data.remaining);
    } catch {
      // Offline fallback - still allow
    }

    setIsRevealing(true);
    setCurrentCard(null);

    setTimeout(() => {
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * cards.length);
      } while (newIndex === lastPulledIndex && cards.length > 1);
      
      setLastPulledIndex(newIndex);
      setCurrentCard(cards[newIndex]);
      setIsRevealing(false);
    }, 500);
  }, [cards, isRevealing, lastPulledIndex, limitReached]);

  const saveCard = () => {
    if (!currentCard) return;
    const updated = [...savedCards, { text: currentCard, date: new Date().toLocaleDateString('he-IL') }];
    setSavedCards(updated);
    localStorage.setItem('savedCards', JSON.stringify(updated));
  };

  const isSaved = currentCard && savedCards.some(c => c.text === currentCard);

  if (!isOpen) return null;

  const handleBookCall = () => {
    onClose();
    setTimeout(() => {
      onBookCall && onBookCall();
    }, 300);
  };

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)' }}
      onClick={onClose}
      data-testid="card-game-overlay"
    >
      <div 
        className="relative w-full max-w-md mx-4 flex flex-col items-center"
        onClick={e => e.stopPropagation()}
        dir={language === 'he' ? 'rtl' : 'ltr'}
        data-testid="card-game-modal"
      >
        {/* Close button - visible */}
        <button
          onClick={onClose}
          className="absolute -top-2 -right-2 w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-lg hover:bg-gray-100 transition-all hover:scale-110 z-10"
          data-testid="card-game-close"
        >
          <X size={20} style={{ color: 'var(--charcoal)' }} />
        </button>

        {/* Saved cards toggle */}
        {savedCards.length > 0 && (
          <button
            onClick={() => setShowSaved(!showSaved)}
            className="absolute top-0 left-0 p-2 rounded-full bg-white/10 hover:bg-white/20 transition-colors z-10"
            data-testid="card-game-saved-toggle"
          >
            <Bookmark size={20} className="text-white" />
          </button>
        )}

        {/* Saved cards list */}
        {showSaved && (
          <div className="w-full bg-white rounded-3xl p-6 mb-4 max-h-60 overflow-y-auto shadow-2xl">
            <div className="flex items-center justify-between mb-3">
              <h3 className="text-sm font-medium" style={{ color: 'var(--charcoal)' }}>
                {language === 'he' ? 'קלפים ששמרתי' : 'Saved Cards'}
              </h3>
              <button onClick={() => setShowSaved(false)}>
                <ArrowLeft size={16} className="text-gray-400" />
              </button>
            </div>
            {savedCards.map((card, i) => (
              <div key={i} className="py-2 border-b border-gray-100 last:border-0">
                <p className="text-sm text-gray-700">{card.text}</p>
                <p className="text-xs text-gray-400 mt-1">{card.date}</p>
              </div>
            ))}
          </div>
        )}

        {/* Card area */}
        <div className="w-full flex flex-col items-center">
          
          {/* The card */}
          {currentCard ? (
            <div 
              className="w-full bg-white rounded-3xl shadow-2xl p-10 md:p-12 mb-6 card-appear"
              style={{ minHeight: '220px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              data-testid="card-display"
            >
              <p 
                className="text-xl md:text-2xl text-center leading-relaxed"
                style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
              >
                {currentCard}
              </p>
            </div>
          ) : (
            <div 
              className="w-full rounded-3xl shadow-2xl p-10 md:p-12 mb-6 flex flex-col items-center justify-center"
              style={{ 
                minHeight: '220px',
                background: isRevealing 
                  ? 'linear-gradient(135deg, var(--sage-100), var(--sand-100))' 
                  : 'linear-gradient(135deg, var(--sage-50), var(--sand-50))',
                border: '2px dashed var(--sage-300)',
                transition: 'all 0.3s ease',
              }}
            >
              {isRevealing ? (
                <div className="animate-pulse">
                  <Sparkles size={32} style={{ color: 'var(--sage-500)' }} />
                </div>
              ) : (
                <p className="text-base text-gray-400 text-center">
                  {language === 'he' ? 'הקלף שלך מחכה...' : 'Your card awaits...'}
                </p>
              )}
            </div>
          )}

          {/* Micro copy after card */}
          {currentCard && (
            <p className="text-white/70 text-sm mb-6 text-center card-appear-delay">
              {language === 'he' ? 'איך זה פוגש אותך היום?' : 'How does this meet you today?'}
            </p>
          )}

          {/* Action buttons */}
          <div className="flex items-center gap-3 mb-6">
            {!currentCard && !limitReached && (
              <button
                onClick={pullCard}
                disabled={isRevealing}
                className="px-8 py-3 rounded-full text-white font-medium transition-all hover:scale-105 active:scale-95 disabled:opacity-50"
                style={{ backgroundColor: 'var(--sage-600)' }}
                data-testid="card-pull-btn"
              >
                {language === 'he' ? 'שלוף קלף' : 'Pull a Card'}
              </button>
            )}

            {currentCard && !limitReached && (
              <>
                <button
                  onClick={pullCard}
                  disabled={isRevealing}
                  className="flex items-center gap-2 px-6 py-3 rounded-full text-white font-medium transition-all hover:scale-105 active:scale-95"
                  style={{ backgroundColor: 'var(--sage-600)' }}
                  data-testid="card-another-btn"
                >
                  <RefreshCw size={16} />
                  {language === 'he' ? 'תן לי עוד אחד' : 'Give me another'}
                </button>
                <button
                  onClick={saveCard}
                  disabled={isSaved}
                  className="flex items-center gap-2 px-5 py-3 rounded-full bg-white/15 text-white font-medium transition-all hover:bg-white/25 disabled:opacity-40"
                  data-testid="card-save-btn"
                >
                  <Bookmark size={16} />
                  {isSaved 
                    ? (language === 'he' ? 'נשמר' : 'Saved')
                    : (language === 'he' ? 'שמור את זה' : 'Save this')
                  }
                </button>
              </>
            )}
          </div>

          {/* Remaining pulls */}
          {!limitReached && (
            <p className="text-white/40 text-xs mb-4">
              {language === 'he' 
                ? `${remaining} שליפות נותרו`
                : `${remaining} pulls remaining`
              }
            </p>
          )}

          {/* Limit reached */}
          {limitReached && (
            <div className="text-center mb-4">
              <p className="text-white/70 text-sm mb-2">
                {language === 'he' 
                  ? 'ניצלת את 3 השליפות שלך. חזור/י בעוד כמה שעות.'
                  : 'You\'ve used your 3 pulls. Come back in a few hours.'
                }
              </p>
            </div>
          )}

          {/* CTA */}
          <div className="text-center">
            <p className="text-white/50 text-sm mb-3">
              {language === 'he' ? 'רוצה לעבוד על זה יחד?' : 'Want to work on this together?'}
            </p>
            <button
              onClick={handleBookCall}
              className="px-6 py-2.5 rounded-full text-sm font-medium transition-all hover:scale-105"
              style={{ backgroundColor: 'var(--sand-300)', color: 'var(--charcoal)' }}
              data-testid="card-cta-btn"
            >
              {language === 'he' ? 'קבע שיחה' : 'Schedule a Call'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardGameModal;
